// Removed unused imports from graph API
import { KlineInterval } from '@synfutures/sdks-perp-datasource';
import { SYN_API_URLS } from './api';

export const QUERY_KEYS = {
  GRAPH: {
    VIRTUAL_TRADE_HISTORY: (args: {
      chainId?: number;
      userAddress?: string;
      timeRange?: string;
      instrumentAddress?: string;
      expiry?: number;
    }) => ['graph/virtual-trade-history', args],
    ORDERS_HISTORY: (args: {
      chainId?: number;
      userAddress?: string;
      timeRange?: string;
      instrumentAddress?: string;
      expiry?: number;
    }) => ['graph/virtual-orders', args],
    FUNDING_HISTORY: (args: {
      chainId?: number;
      userAddress?: string;
      timeRange?: string;
      instrumentAddress?: string;
      expiry?: number;
    }) => ['graph/virtual-funding', args],
    TRANSFERS_HISTORY: (args: {
      chainId?: number;
      userAddress?: string;
      timeRange?: string;
      instrumentAddress?: string;
      expiry?: number;
    }) => ['graph/virtual-transfers', args],
    LIQUIDITY_HISTORY: (args: {
      chainId?: number;
      userAddress?: string;
      timeRange?: string;
      instrumentAddress?: string;
      expiry?: number;
    }) => ['graph/virtual-liquidity', args],
    ACCOUNT_BALANCE_HISTORY: (args: { chainId?: number; userAddress?: string; timeRange?: string }) => [
      'graph/virtual-account-balance',
      args,
    ],
    ALL_INSTRUMENTS_BASIC_INFO: (chainId?: number) => ['graph/all-instruments-basic-info', { chainId }],
  },
  CAMPAIGN: {
    CAMPAIGNS: () => ['/v3/public/campaign', 'campaigns'],
    LEADERBOARD: (campaignId?: number, userAddress?: string) => [
      '/v3/public/campaign/<campaignId>?address=<userAddress>',
      { campaignId, userAddress },
    ],
  },
  GLOBAL: {
    TOKEN_PRICE: (chainId?: number) => [SYN_API_URLS.GLOBAL.TOKEN_PRICE, { chainId }],
  },
  FUTURES: {
    INSTRUMENT: (chainId?: number, instrumentAddress?: string) => [
      SYN_API_URLS.FUTURES.INSTRUMENT,
      { chainId, instrumentAddress },
    ],
    PAIR_INFO: (chainId?: number, instrumentAddress?: string, expiry?: number) => [
      SYN_API_URLS.MARKET.PAIR_INFO,
      { chainId, instrumentAddress, expiry },
    ],
    ORDER_BOOK: (chainId?: number, instrumentAddress?: string, expiry?: number, stepRatio?: number) => [
      SYN_API_URLS.FUTURES.ORDER_BOOK,
      { chainId, instrumentAddress, expiry, stepRatio },
    ],
    DEPTH_CHARTS: (chainId?: number, instrumentAddress?: string, expiry?: number) => [
      SYN_API_URLS.FUTURES.DEPTH_CHARTS,
      { chainId, instrumentAddress, expiry },
    ],
    FUNDING_CHARTS: (chainId?: number, instrumentAddress?: string, expiry?: number, chartDuration?: string) => [
      SYN_API_URLS.FUTURES.FUNDING_CHARTS,
      { chainId, instrumentAddress, expiry, chartDuration },
    ],
    KLINE_CHARTS: ({
      chainId,
      instrumentAddress,
      expiry,
      chartDuration,
      timeEnd,
    }: {
      chainId?: number;
      instrumentAddress?: string;
      expiry?: number;
      chartDuration?: KlineInterval;
      timeEnd?: number;
    }) => [
      SYN_API_URLS.FUTURES.KLINE_CHARTS,
      {
        chainId,
        instrumentAddress,
        expiry,
        chartDuration,
        timeEnd,
      },
    ],

    INSTRUMENT_INQUIRE: (chainId?: number, instrumentAddress?: string, expiry?: number, size?: string) => [
      SYN_API_URLS.FUTURES.INSTRUMENT_INQUIRE,
      { chainId, instrumentAddress, expiry, size },
    ],
    INSTRUMENT_INQUIRE_BY_TICK: (chainId?: number, instrumentAddress?: string, expiry?: number, tick?: number) => [
      SYN_API_URLS.FUTURES.INSTRUMENT_INQUIRE_BY_TICK,
      { chainId, instrumentAddress, expiry, tick },
    ],
    INSTRUMENT_INQUIRE_BY_NOTIONAL: (
      chainId?: number,
      instrumentAddress?: string,
      expiry?: number,
      notional?: string,
      long?: boolean,
    ) => [SYN_API_URLS.FUTURES.INSTRUMENT_INQUIRE_BY_NOTIONAL, { chainId, instrumentAddress, expiry, notional, long }],
  },
  MARKET: {
    PAIR_LIST: (chainId?: number) => [SYN_API_URLS.MARKET.PAIR_LIST, { chainId }],
  },
  VAULT: {
    INFOS: (chainId?: number, userAddr?: string) => [SYN_API_URLS.VAULT.INFOS, { chainId, userAddr }],
    SUMMARY: (chainId?: number) => [SYN_API_URLS.VAULT.SUMMARY, { chainId }],
  },
  PORTFOLIO: {
    PORTFOLIO: (chainId?: number, userAddress?: string, instrumentAddress?: string, expiry?: number) => [
      SYN_API_URLS.PORTFOLIO.USER_PORTFOLIO,
      { chainId, userAddress, instrumentAddress, expiry },
    ],
    USER_VOLUME: (chainId?: number, userAddress?: string) => [
      SYN_API_URLS.PORTFOLIO.USER_VOLUME,
      { chainId, userAddress },
    ],
  },
  EARN: {
    IL: (chainId?: number, symbol?: string, alphaLower?: string, alphaUpper?: string) => [
      'ildata',
      chainId,
      symbol,
      alphaLower,
      alphaUpper,
    ],
    LIQ_CHART: (chainId?: number, instrumentAddress?: string, expiry?: number) => [
      SYN_API_URLS.FUTURES.LIQUIDITY_CHARTS,
      { chainId, instrumentAddress, expiry },
    ],
    WHITELIST: (chainId?: number, userAddress?: string, quoteTokenAddress?: string) => [
      'sdk.perp.config.inWhiteListLps',
      { chainId, userAddress, quoteTokenAddress },
    ],
  },
  BALANCE: {
    GATE: (chainId?: number, userAddr?: string) => [SYN_API_URLS.PORTFOLIO.USER_GATE_VALUE, { chainId, userAddr }],
    TOKEN_BALANCE: (chainId?: number, userAddress?: string, spender?: string) => [
      SYN_API_URLS.PORTFOLIO.USER_ALL_TOKEN_BALANCE,
      { chainId, userAddress, spender },
    ],
  },
  AGENT: {
    AGENT_ADDRESS_FROM_CHAIN: (chainId?: number, userAddr?: string) => [
      'routerContract.callStatic.getSubAccount',
      { chainId, userAddr },
    ],
  },
  USER: {
    IS_BLACKLISTED: (chainId?: number, userAddress?: string) => [
      'sdk.perp.contracts.gate.isBlacklisted',
      { chainId, userAddress },
    ],
  },
  TRADE: {
    SIMULATE_MARKET_TRADE: ({
      chainId,
      userAddr,
      base,
      tradeSide,
      leverage,
      slippage,
      margin,
      maxLeverage,
    }: {
      chainId?: number;
      userAddr?: string;
      base?: string;
      tradeSide?: string;
      leverage?: string;
      slippage?: number;
      margin?: string;
      maxLeverage?: number;
    }) => [
      'tradeForm/simulate',
      {
        chainId,
        userAddr,
        base,
        tradeSide,
        leverage,
        slippage,
        margin,
        maxLeverage,
      },
    ],
    SIMULATE_BATCH_PLACE_SCALED_LIMIT_ORDER: ({
      chainId,
      userAddr,
      orderCount,
      stepRatio,
      lowerTick,
      upperTick,
      lowerPrice,
      upperPrice,
      tradeSize,
      sizeDistribution,
      leverage,
      tradeSide,
    }: {
      chainId?: number;
      userAddr?: string;
      orderCount?: number;
      stepRatio?: number;
      lowerTick?: number;
      upperTick?: number;
      lowerPrice?: string;
      upperPrice?: string;
      tradeSize?: string;
      sizeDistribution?: number;
      leverage?: string;
      tradeSide?: string;
    }) => [
      'tradeForm/simulateBatchPlaceScaledLimitOrder',
      {
        chainId,
        userAddr,
        orderCount,
        stepRatio,
        lowerTick,
        upperTick,
        lowerPrice,
        upperPrice,
        tradeSize,
        sizeDistribution,
        leverage,
        tradeSide,
      },
    ],
  },
} as const;
